import React, { useMemo } from 'react';
import * as S from '../PlacementsForm.styled';
import {
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';
import SectionItem from './SectionItem';

const Section = ({ data }) => {
  const placementNamesList = useMemo(() => {
    const res = data
      .map((item) => {
        if (item.status !== '9') {
          return item.name;
        }
      })
      .filter(Boolean);
    return res;
  }, [data]);

  return (
    <S.SectionContainer>
      <S.Head>Placements</S.Head>
      <Paper sx={S.paperStyle}>
        <TableContainer sx={{ maxHeight: 455 }}>
          <Table stickyHeader aria-label='sticky table'>
            <TableHead>
              <TableRow>
                <TableCell sx={S.headTableCellStyle}>Placement</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* '9' - it is archived placements */}
              {data?.map(
                (item) =>
                  item.status !== '9' && (
                    <SectionItem key={item?.id} {...item} placementNames={placementNamesList} />
                  ),
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </S.SectionContainer>
  );
};

export default Section;
